import { ConsoleLogger, HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface KsefGetUpoXmlQueryParams {
    ksefDocumentId: string;
}

export interface KsefGetUpoXmlQueryResult {
    readonly xml: Blob;
}

export class KsefGetUpoXmlQuery extends Query<KsefGetUpoXmlQueryResult | undefined> {
    public constructor(public readonly params: KsefGetUpoXmlQueryParams) {
        super();
    }
}

export class KsefGetUpoXmlQueryHandlerBase implements QueryHandler<KsefGetUpoXmlQuery> {
    private static Url = TaggedUrl.join('eInvoices/upo/:ksefDocumentId/xml', [Tags.Api]);

    private readonly logger = new ConsoleLogger(this.constructor.name);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ params }: KsefGetUpoXmlQuery): Promise<KsefGetUpoXmlQueryResult | undefined> {
        try {
            const url = fillPlaceholders(KsefGetUpoXmlQueryHandlerBase.Url, { ksefDocumentId: params.ksefDocumentId });
            const { data: xml } = await this.http.get<Blob>(url, {
                responseType: 'blob'
            });

            return { xml };
        } catch (err) {
            this.logger.error(err);
        }

        return undefined;
    }
}
